<!-- Section: Pricing table -->
<section id="one" class="pricing-table d-flex align-items-center text-left">

  <div class="container">
    <div class="row">
      <h2 class="white-text text-center mb-3 col">Pricing</h2>
    </div>

    <div class="row justify-content-center">
      <!-- Standard Tier -->
      <div class="col-lg-4">
        <div class="card mb-5 mb-lg-0">
          <div class="card-body">
            <h5 class="card-title grey-text text-uppercase text-center">Standard</h5>
            <h6 class="card-price text-center">$30<span class="term">/user/month</span></h6>
            <hr class="my-4">
            <ul class="fa-ul">
              <li><span class="fa-li"><i class="fa fa-check"></i></span>1-50 Users</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Unlimited clients</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Unlimited assessments and assessment batteries</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Unlimited homework exercises and articles</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Assignment completion notifications</li>
              <li class="grey-text"><span class="fa-li"><i class="fa fa-times"></i></span>Whitelabel Domain
              </li>
              <li class="grey-text"><span class="fa-li"><i class="fa fa-times"></i></span>Whitelabel Emails
              </li>
              <li class="grey-text"><span class="fa-li"><i class="fa fa-times"></i></span>Whitelabel Reports
              </li>
              <li class="grey-text"><span class="fa-li"><i class="fa fa-times"></i></span>Embed assessments on external
                site</li>
            </ul>
            <a (click)="selectPlan('Therapist')" class="btn btn-block btn-primary z-depth-0 btn-rounded my-2">Signup for
              14 day free trial</a>
          </div>
        </div>
      </div>
      <!-- Advanced Tier -->
      <div class="col-lg-4">
        <div class="card mb-5 mb-lg-0">
          <div class="card-body">
            <h5 class="card-title grey-text text-uppercase text-center">Custom</h5>
            <h6 class="card-price text-center"><span class="term">By Quote</span></h6>
            <hr class="my-4">
            <ul class="fa-ul">
              <li><span class="fa-li"><i class="fa fa-check"></i></span><strong>50+ Users</strong></li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Unlimited clients</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Unlimited assessments and assessment batteries</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Unlimited homework exercises and articles</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Assignment completion notifications</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Whitelabel Domain</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Whitelabel Emails</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Whitelabel Reports</li>
              <li><span class="fa-li"><i class="fa fa-check"></i></span>Embed assessments on external site</li>
            </ul>
            <a [routerLink]="['/contact']" class="btn btn-block btn-primary z-depth-0 btn-rounded my-2">Contact Us</a>
          </div>
        </div>
      </div>
    </div>

  </div>

</section>


// WEBPACK FOOTER //
// ./src/app/pricing-table/pricing-table.component.html